"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BellOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_BellOff_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.854a.5.5 0 0 0-.708-.708l-15 15a.5.5 0 0 0 .708.708L2.707 14H6a2 2 0 1 0 4 0h3.748c1.065 0 1.934-.882 1.934-1.963 0-.533-.206-1.036-.587-1.39l-.27-.274a5.942 5.942 0 0 1-1.697-4.17 5.24 5.24 0 0 0-.463-2.16l3.189-3.19Zm-3.959 3.958L3.707 13h10.04c.5 0 .935-.42.935-.963a.885.885 0 0 0-.3-.689l-.269-.273a6.942 6.942 0 0 1-1.985-4.871c0-.489-.082-.957-.233-1.392ZM8 15a1 1 0 0 1-1-1h2a1 1 0 0 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.995 1.098c.951.19 1.808.649 2.492 1.294l-.707.707A4.076 4.076 0 0 0 8 2C5.738 2 3.873 3.872 3.873 6.204c0 1.82-.71 3.575-1.986 4.87l-.27.274-.03.03a.884.884 0 0 0-.269.659c0 .154.036.299.097.426l-.726.727a1.971 1.971 0 0 1-.37-1.153c0-.533.205-1.036.586-1.39l.27-.274a5.942 5.942 0 0 0 1.698-4.17c0-2.524 1.779-4.633 4.132-5.105a1 1 0 1 1 1.99 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_BellOff_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = BellOff;
exports["default"] = _default;